module.exports = __webpack_public_path__ + "media/flags/zh-211ca632.svg";